var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64352 0L4.65685 4.64495L0.0219667 5.74965L4.6851 6.73208L5.79413 11.3501L6.77962 6.70395L11.4153 5.60082L6.75255 4.618L5.64352 0ZM17.88 0.211183L14.2377 3.83913L16.2243 5.81802L19.8663 2.18993L17.88 0.211183ZM12.9129 5.15848L0 18.0211L1.9865 20L14.8994 7.1374L12.9128 5.15848H12.9129ZM16.9169 7.46202L16.3898 9.94367L13.913 10.5347L16.4043 11.0593L16.9965 13.5265L17.5232 11.0449L20 10.4538L17.5086 9.92918L16.9169 7.46202ZM12.8541 11.9714L12.2733 14.7082L9.54273 15.3578L12.2894 15.9363L12.9424 18.657L13.5232 15.9203L16.2537 15.2699L13.5075 14.691L12.8541 11.9714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssist);
export default __webpack_public_path__ + "static/media/icon-assist.934532431242d093f85bd07d2aef662c.svg";
export { ForwardRef as ReactComponent };